import messages from '~/constants/localizations/teamStats';
import { Schema } from './index.d';

export const WNBA_PREGAME: Schema[] = [
  {
    key: 'pace',
    meta_key: 'pace_rank',
    label: 'Pace',
    localized_label: messages.basketball.pace,
  },
  {
    key: 'field_goals_percentage',
    meta_key: 'field_goals_percentage_rank',
    label: 'FG (%)',
    localized_label: messages.basketball.field_goals_percentage,
  },
  {
    key: 'three_point_field_goals_made_average',
    meta_key: 'three_point_field_goals_made_average_rank',
    label: '3PT FG',
    localized_label: messages.basketball.three_point_field_goals_made_average,
  },
  {
    key: 'three_point_field_goals_percentage',
    meta_key: 'three_point_field_goals_percentage_rank',
    label: '3PT FG (%)',
    localized_label: messages.basketball.three_point_field_goals_percentage,
  },
  {
    key: 'free_throws_percentage',
    meta_key: 'free_throws_percentage_rank',
    label: 'FT (%)',

    localized_label: messages.basketball.free_throws_percentage,
  },
  {
    key: 'rebounds_total_average',
    meta_key: 'rebounds_total_averge_rank',
    label: 'Rebounds',
    localized_label: messages.basketball.rebounds_total_average,
  },
  {
    key: 'rebounds_offensive_average',
    meta_key: 'rebounds_offensive_average_rank',
    label: 'Offensive Rebounds',
    localized_label: messages.basketball.rebounds_offensive_average,
  },
  {
    key: 'assists_average',
    meta_key: 'assists_average_rank',
    label: 'Assists',
    localized_label: messages.basketball.assists_average,
  },
  {
    key: 'assist_rate',
    meta_key: 'assist_rate_rank',
    label: 'Assist (%)',

    localized_label: messages.basketball.assist_rate,
  },
  {
    key: 'steals_average',
    meta_key: 'steals_average_rank',
    label: 'Steals',
    localized_label: messages.basketball.steals_average,
  },
  {
    key: 'turnovers_average',
    meta_key: 'turnovers_average_rank',
    label: 'Turnovers',
    localized_label: messages.basketball.turnovers,
  },
];

export const WNBA: Schema[] = [
  {
    key: ['field_goals_made', 'field_goals_attempted', 'field_goals_percentage'],
    percentage: 'field_goals_percentage',
    label: 'Field Goals',
    format: (made, attempts, percentage) =>
      `${made}/${attempts} (${Math.trunc(percentage * 100)}%)`,
    localized_label: messages.basketball.field_goals_percentage,
  },
  {
    key: [
      'three_point_field_goals_made',
      'three_point_field_goals_attempted',
      'three_point_field_goals_percentage',
    ],
    percentage: 'three_point_field_goals_percentage',
    label: '3 Pointers',
    format: (made, attempts, percentage) =>
      `${made}/${attempts} (${Math.trunc(percentage * 100)}%)`,
    localized_label: messages.basketball.three_point_field_goals_percentage,
  },
  {
    key: ['free_throws_made', 'free_throws_attempted', 'free_throws_percentage'],
    percentage: 'free_throws_percentage',
    label: 'Free Throws',
    format: (made, attempts, percentage) =>
      `${made}/${attempts} (${Math.trunc(percentage * 100)}%)`,
    localized_label: messages.basketball.free_throws_percentage,
  },
  {
    key: 'rebounds_total',
    label: 'Rebounds',
    localized_label: messages.basketball.rebounds_total,
  },
  {
    key: 'rebounds_offensive',
    label: 'Offensive Rebounds',
    localized_label: messages.basketball.rebounds_offensive,
  },
  {
    key: 'assists',
    label: 'Assists',
    localized_label: messages.basketball.assists,
  },
  {
    key: 'steals',
    label: 'Steals',
    localized_label: messages.basketball.steals,
  },
  {
    key: 'blocked_shots',
    label: 'Blocks',
    localized_label: messages.basketball.blocked_shots,
  },
  {
    key: 'turnovers',
    label: 'Turnovers',
    localized_label: messages.basketball.turnovers,
    isNegative: true,
  },
  {
    key: 'personal_fouls',
    label: 'Fouls (pers)',
    localized_label: messages.basketball.personal_fouls,
  },
];
